module.exports = __webpack_public_path__ + "img/3.6a8fb350.jpg";